export default __webpack_public_path__ + "static/media/5t.1715a016.jpg";